export default "__VITE_ASSET__N_i_fyds__"